const PPTGenerate = {
    pptLogin: process.env.REACT_APP_PPT_LOGIN_BASEPATH,
    pptGenerate: process.env.REACT_APP_PPT_GENERATE_BASEPATH,
};

export default PPTGenerate;
